import { FunctionComponent } from 'react';

export const IntegrationHome: FunctionComponent = () => {
  return <div>Hello integration home page!</div>;
};

IntegrationHome.displayName = 'IntegrationHome';
